import type { Skin } from './types';

/**
 * The dragon-pets palette: every color has a fixed shade partner used for
 * the shadow crescent, so art stays two-tone + ink like a picture book.
 */
export const PALETTE = [
  '#414c5d', // slate
  '#eaeceb', // chalk
  '#f26b61', // coral
  '#f6883e', // orange
  '#fbe788', // butter
  '#9fd18b', // leaf
  '#98d5c7', // mint
  '#7cd0e0', // sky
  '#4995d1', // blue
  '#f389ae', // pink
  '#b46fae', // plum
] as const;

export const SHADE: Record<string, string> = {
  '#414c5d': '#303948',
  '#eaeceb': '#BEC6CA',
  '#f26b61': '#BB4347',
  '#f6883e': '#C0552D',
  '#fbe788': '#D9AC65',
  '#9fd18b': '#799D68',
  '#98d5c7': '#6AB9AE',
  '#7cd0e0': '#4DABBF',
  '#4995d1': '#3D619A',
  '#f389ae': '#DC697F',
  '#b46fae': '#7E447E',
};

export const INK = '#414c5d';
export const CREAM = '#fffdf0';

export const paletteColor = (i: number): string => PALETTE[((i % PALETTE.length) + PALETTE.length) % PALETTE.length]!;
export const shadeOf = (hex: string): string => SHADE[hex] ?? hex;

/** Body colors that read well against the lava/island — skips slate and chalk. */
const ORB_PRIMARIES = [2, 3, 5, 6, 7, 8, 9, 10];

const EYES = ['dot', 'glee', 'sleepy', 'square'] as const;
const MOUTHS = ['smile', 'fangs', 'flat', 'kissy'] as const;

/** Deterministic default skin for the n-th player to join a room. */
export function defaultSkin(n: number): Skin {
  const primary = ORB_PRIMARIES[n % ORB_PRIMARIES.length]!;
  return {
    primary,
    secondary: 4, // butter highlight for everyone by default
    eyes: EYES[n % EYES.length]!,
    mouth: MOUTHS[(n * 3) % MOUTHS.length]!,
  };
}
